var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { addGlobalLiveEventListener, getFetchOptions, startIconLoading, stopIconLoading } from "../../utils";
import { StatusClassNames } from "../../types/StatusClassNames";
import EventBus from "../../events/EventBus";
import { useFavoritesApi } from "../../api/favoritesApi";
var api;
function highlightFavorites(updateBrands) {
    var e_1, _a;
    if (updateBrands === void 0) { updateBrands = true; }
    var brandsUpdated = false;
    try {
        for (var _b = __values(document.querySelectorAll(".favorite-button")), _c = _b.next(); !_c.done; _c = _b.next()) {
            var el = _c.value;
            var brand = el.dataset.brand !== undefined;
            var status = api.has(parseInt(el.dataset.id), brand);
            if (status) {
                el.classList.add(StatusClassNames.filled);
            }
            else {
                el.classList.remove(StatusClassNames.filled);
            }
            if (brand) {
                brandsUpdated = true;
                updateBrandCategories(el, status);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (brandsUpdated && updateBrands) {
        EventBus.emit('brands:update');
    }
}
addGlobalLiveEventListener('click', '.favorite-button', function (e) {
    return __awaiter(this, void 0, void 0, function () {
        var id, brand, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = parseInt(this.dataset.id);
                    brand = this.dataset.brand !== undefined;
                    e.preventDefault();
                    startIconLoading(this);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, useFavoritesApi().toggleFavorite(id, brand)];
                case 2:
                    status = _a.sent();
                    if (status) {
                        this.classList.add(StatusClassNames.filled);
                        if (!brand) {
                            window.vkEvent(process.env.VK_PRICE_LIST_ID, 'add_to_wishlist', { products: [{ id: id }] });
                        }
                    }
                    else {
                        this.classList.remove(StatusClassNames.filled);
                    }
                    if (brand) {
                        updateBrandCategories(this, status);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    stopIconLoading(this);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
});
function updateBrandCategories(button, status) {
    var _a;
    var parentListItem = button.closest('.abc-nav__item');
    if (!parentListItem) {
        return;
    }
    var list = new Set(((_a = parentListItem.dataset.category) !== null && _a !== void 0 ? _a : '').split(' '));
    if (status) {
        list.add('favorite');
    }
    else {
        list.delete('favorite');
    }
    parentListItem.dataset.category = __spreadArray([], __read(list), false).join(' ');
}
function onChange(event) {
    var checkbox = event.target;
    var fieldset = checkbox.closest('fieldset');
    fieldset.disabled = true;
    var body = {
        id: parseInt(checkbox.value),
        shelf: checkbox.name,
        remove: !checkbox.checked,
    };
    fetch('/api/wardrobe/append', getFetchOptions(body, true))
        .finally(function () { return fieldset.disabled = false; });
}
export default function initFavorites() {
    api = useFavoritesApi();
    EventBus.on('favorites:change', function () { return highlightFavorites(); });
    window.addEventListener('pageshow', function () { return highlightFavorites(); });
    EventBus.on('products:load', function () { return highlightFavorites(false); });
    EventBus.on('modal:open', function (modal) {
        if (modal.id === 'modal-add-to-favourites') {
            modal.querySelectorAll('input[type=checkbox]')
                .forEach(function (checkbox) { return checkbox.addEventListener('change', onChange); });
        }
    });
    EventBus.on('modal:close', function (modal) {
        if (modal.id === 'modal-add-to-favourites') {
            modal.querySelectorAll('input[type=checkbox]')
                .forEach(function (checkbox) { return checkbox.removeEventListener('change', onChange); });
        }
    });
}
